import React, { useEffect, useRef, useState } from 'react';
import { siteData } from '../data/mock';

const AnimatedCard = ({ children, delay = 0, style = {} }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
        transition:
          'opacity 0.6s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.6s cubic-bezier(0.25,0.46,0.45,0.94)',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const OurBetStory = () => {
  const bet = siteData.betSection;
  const story = siteData.storySection;

  return (
    <section className="relative w-full" style={{ background: '#fff' }}>
      <div
        className="section-pad betstory-layout"
        style={{
          gap: '24px',
          alignItems: 'stretch',
        }}
      >
        {/* Left: OUR BET card */}
        <AnimatedCard delay={0} style={{ flex: 1, display: 'flex' }}>
          <div
            className="why-card-macos"
            style={{
              flex: 1,
              border: '1px solid #c0c5ce',
              borderRadius: '12px',
              padding: 'clamp(22px, 5vw, 40px)',
              background: '#fff',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              cursor: 'default',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                fontFamily: 'InterVariable, sans-serif',
                fontSize: '13px',
                fontWeight: 600,
                color: '#fff',
                background: '#FF98BF',
                borderRadius: '6px',
                padding: '4px 12px',
                marginBottom: '28px',
                width: 'fit-content',
                letterSpacing: '0.02em',
              }}
            >
              {bet.badge}
            </span>

            <div style={{ marginBottom: '28px' }}>
              {bet.lines.map((line, i) => (
                <p
                  key={i}
                  style={{
                    fontFamily: 'Coolvetica, sans-serif',
                    fontSize: 'clamp(22px, 4.2vw, 28px)',
                    fontWeight: 400,
                    color: '#999',
                    letterSpacing: '-0.025em',
                    lineHeight: 'clamp(28px, 4.8vw, 36px)',
                  }}
                >
                  {line.text}
                </p>
              ))}
              <p
                style={{
                  fontFamily: 'Coolvetica, sans-serif',
                  fontSize: 'clamp(22px, 4.2vw, 28px)',
                  fontWeight: 400,
                  letterSpacing: '-0.025em',
                  lineHeight: 'clamp(28px, 4.8vw, 36px)',
                }}
              >
                <span style={{ color: '#000' }}>{bet.highlightLine.prefix} </span>
                <span style={{ color: '#FF98BF' }}>{bet.highlightLine.highlight}</span>
              </p>
            </div>

            <p
              style={{
                fontFamily: 'InterVariable, sans-serif',
                fontSize: '15px',
                fontWeight: 400,
                fontStyle: 'italic',
                color: '#000',
                lineHeight: '20px',
              }}
            >
              {bet.body}
            </p>
          </div>
        </AnimatedCard>

        {/* Right: Our Story card */}
        <AnimatedCard delay={200} style={{ flex: 1, display: 'flex' }}>
          <div
            className="why-card-macos"
            style={{
              flex: 1,
              background: '#000',
              borderRadius: '12px',
              padding: '40px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              cursor: 'default',
            }}
          >
            <span
              style={{
                fontFamily: 'Coolvetica, sans-serif',
                fontSize: '22px',
                fontWeight: 400,
                color: '#FF98BF',
                letterSpacing: '-0.025em',
                lineHeight: '26px',
                display: 'block',
                marginBottom: '8px',
              }}
            >
              {story.label}
            </span>

            <h3
              style={{
                fontFamily: 'Coolvetica, sans-serif',
                fontSize: '36px',
                fontWeight: 400,
                color: '#fff',
                letterSpacing: '-0.025em',
                lineHeight: '40px',
                marginBottom: '12px',
              }}
            >
              {story.heading}
            </h3>

            <p
              style={{
                fontFamily: 'InterVariable, sans-serif',
                fontSize: '16px',
                fontWeight: 400,
                fontStyle: 'italic',
                color: '#fff',
                lineHeight: '20px',
                marginBottom: '24px',
              }}
            >
              {story.subtitle}
            </p>

            <button
              onClick={() => window.open('https://open.substack.com/pub/annunjaya/p/how-we-landed-at-demoboy?utm_campaign=post-expanded-share&utm_medium=post%20viewer', '_blank')}
              className="nav-btn-macos"
              style={{
                fontFamily: 'InterVariable, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#000',
                background: '#FF98BF',
                border: 'none',
                borderRadius: '8px',
                padding: '10px 24px',
                cursor: 'pointer',
                width: 'fit-content',
              }}
            >
              {story.cta}
            </button>
          </div>
        </AnimatedCard>
      </div>
    </section>
  );
};

export default OurBetStory;
